import { render, staticRenderFns } from "./TopItemsWidget.vue?vue&type=template&id=02ccdb42&scoped=true&"
import script from "./TopItemsWidget.vue?vue&type=script&lang=js&"
export * from "./TopItemsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TopItemsWidget.vue?vue&type=style&index=0&id=02ccdb42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ccdb42",
  null
  
)

/* custom blocks */
import block0 from "@/locales/topic-types.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fbig-dig-data%2Fshaft%2Fdesign%2Fshaft-ui%2Fsrc%2Fcomponents%2FTopItemsWidget.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/common.yaml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Fbig-dig-data%2Fshaft%2Fdesign%2Fshaft-ui%2Fsrc%2Fcomponents%2FTopItemsWidget.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "./TopItemsWidget.vue?vue&type=custom&index=2&blockType=i18n"
if (typeof block2 === 'function') block2(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VProgressCircular,VTooltip})
